<div class="custom-header">
	<mat-icon svgIcon="chevron-left-icon" (click)="previousClicked('month')" class="chevron-icon"></mat-icon>
	<span class="custom-header-label">{{periodLabel | date:'MMMM y'}}</span>
	<mat-icon svgIcon="chevron-right-icon" (click)="nextClicked('month')" class="chevron-icon"></mat-icon>
</div>